export const LOGIN = 'app/login/login';
